import { render, staticRenderFns } from "./CoatingSelect.vue?vue&type=template&id=2224b94d&scoped=true&"
import script from "./CoatingSelect.vue?vue&type=script&lang=js&"
export * from "./CoatingSelect.vue?vue&type=script&lang=js&"
import style0 from "./CoatingSelect.vue?vue&type=style&index=0&id=2224b94d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2224b94d",
  null
  
)

export default component.exports